import { render, staticRenderFns } from "./svgDribbble.vue?vue&type=template&id=81738ad4&scoped=true"
import script from "./svgDribbble.vue?vue&type=script&lang=js"
export * from "./svgDribbble.vue?vue&type=script&lang=js"
import style0 from "./svgDribbble.vue?vue&type=style&index=0&id=81738ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81738ad4",
  null
  
)

export default component.exports